import type { TourStepData } from './types';

export const roadmapTourSteps: TourStepData[] = [
  {
    target: '[data-tour="roadmap-header"]',
    title: 'Roadmap',
    content:
      'La Roadmap (Feuille de route) est un outil interne pour planifier les strategies marketing, lancement et operations. Creez des jalons correles aux modules Growth.',
    placement: 'bottom',
    glossaryTerm: 'roadmap',
  },
  {
    target: '[data-tour="roadmap-list"]',
    title: 'Vos feuilles de route',
    content:
      'Chaque carte represente une feuille de route avec son statut (brouillon, active, terminee) et sa progression en jalons (Milestones).',
    placement: 'bottom',
    glossaryTerm: 'milestone',
  },
  {
    target: '[data-tour="roadmap-progress"]',
    title: 'Progression',
    content:
      'La barre de progression indique le ratio de jalons termines par rapport au total. Cliquez sur une carte pour voir le detail.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="roadmap-kanban"]',
    title: 'Vues Kanban et Timeline',
    content:
      'Dans le detail d\'une feuille de route, basculez entre la vue Kanban (colonnes par statut) et la vue Timeline (axe chronologique) pour organiser vos jalons.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="roadmap-module-link"]',
    title: 'Modules lies',
    content:
      'Chaque jalon peut etre lie a un module Growth (Blog Manager, Content Calendar, Campaigns...). Un clic navigue directement vers le module concerne.',
    placement: 'bottom',
  },
];
